export default __webpack_public_path__ + "static/media/Balls right.4ef7927c.svg";